import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find-index";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BoardsSelectionTemplate from "@Shared/@HandlebarsTemplates/general/_boards-selection.hbs";
import ProgressBarItem from "./progress-bar-item";
import Select2 from "../../../components/inputs/select2";
import MaterialInput from "../../../components/inputs/material-input";
import ProgressBarLoader from "./progress-bar-loader";
import { cloneDeep, throttle } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ProgressBar",
  components: {
    ProgressBarItem,
    Select2,
    MaterialInput,
    ProgressBarLoader
  },
  props: {
    interactive: {
      type: Boolean,
      default: false
    },
    containerSize: {
      type: Number,
      default: 100
    },
    progress: {
      type: Boolean,
      default: true
    },
    contain: {
      type: Boolean,
      default: false
    },
    customRender: {
      type: Boolean,
      default: false
    },
    steps: {
      type: Array,
      required: true
    },
    selectedSteps: {
      type: [Array, String],
      default: ""
    },
    loading: {
      type: Boolean
    },
    dynamicScroll: {
      type: Boolean,
      default: true
    },
    responsive: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      MAX_WINDOW_SIZE: 576,
      STATES_DISTANCE_DELTA: 6,
      SPACE_THRESHOLD: 30,
      smallScreen: false,
      addScroll: false,
      loadingDistance: false,
      windowSize: 0
    };
  },
  computed: {
    computedAddScroll() {
      if (!this.dynamicScroll) return false;
      return this.addScroll;
    },
    computedSmallScreen() {
      if (!this.responsive) return false;
      return this.smallScreen;
    },
    fillBarStyle() {
      if (!this.progress) return;
      const totalSteps = this.steps.length;
      const stepSize = this.containerSize / (totalSteps - 1 || 1);
      if (this.selectedStepIndex < 0) return "width: 0;";
      return `width: ${stepSize * this.selectedStepIndex}%;`;
    },
    wrapperClass() {
      return {
        "pb-interactive": this.interactive,
        "pb-no-progress": !this.progress,
        "pb-contain": this.contain
      };
    },
    //Only to get single step selected when progress mode
    selectedStep() {
      return Array.isArray(this.selectedSteps) ? this.selectedSteps[0] : this.selectedSteps;
    },
    selectedStepIndex() {
      var _context;
      return _findIndexInstanceProperty(_context = this.steps).call(_context, value => {
        const id = value.id || value;
        return id === this.selectedStep;
      });
    },
    numberOfSteps() {
      return this.steps.length;
    },
    progressBarLoadingClass() {
      return this.loading || this.loadingDistance ? "invisible position-absolute w-100" : "";
    },
    options() {
      const formatResult = state => $(BoardsSelectionTemplate(state));
      return {
        templateResult: formatResult,
        allowClear: false,
        closeOnSelect: true,
        dropdownCssClass: "states-select",
        escapeMarkup(markup) {
          return markup;
        }
      };
    },
    progressBarWidthStyle() {
      let widthStyle = "";
      if (this.computedAddScroll) {
        widthStyle = `calc(${this.containerSize}% + ${this.numberOfSteps * this.STATES_DISTANCE_DELTA}rem)`;
      } else {
        widthStyle = `${this.containerSize}%`;
      }
      return `width: ${widthStyle}`;
    }
  },
  watch: {
    windowSize(value) {
      this.smallScreen = value < this.MAX_WINDOW_SIZE;
      this.loadingDistance = true;
      this.recalculateStateDistance();
      this.loadingDistance = false;
    },
    numberOfSteps(value) {
      if (value) {
        this.loadingDistance = true;
        this.recalculateStateDistance();
        this.loadingDistance = false;
      }
    },
    smallScreen(value, oldValue) {
      if (!this.responsive) return;
      if (!value && value != oldValue) {
        this.loadingDistance = true;
        this.recalculateStateDistance();
        this.loadingDistance = false;
      }
    }
  },
  beforeMount() {
    window.addEventListener("resize", this.onResize);
  },
  mounted() {
    this.loadingDistance = true;
    this.recalculateStateDistance();
    this.loadingDistance = false;
  },
  activated() {
    this.loadingDistance = true;
    this.recalculateStateDistance();
    this.loadingDistance = false;
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    handleSelectStatus(data) {
      if (!this.interactive) return;
      this.$emit("change", data);
    },
    assignClass(index) {
      if (!this.progress) return;
      return {
        done: index < this.selectedStepIndex,
        current: index === this.selectedStepIndex
      };
    },
    onResize() {
      this.windowSize = window.innerWidth;
    },
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => _objectSpread(_objectSpread({}, ref), {}, {
        text: `${ref.value}`
      }));
    },
    recalculateStateDistance: throttle(function () {
      this.addScroll = false;
      this.$nextTick(() => {
        var _context2;
        const states = _findInstanceProperty(_context2 = $(this.$el)).call(_context2, ".status-inner > *");
        if (states.length > 1) {
          const distances = [];
          for (let index = 0; index + 1 < states.length; index++) {
            const firstRect = $(states[index]);
            const secondRect = $(states[index + 1]);
            const difference = secondRect.offset().left - (firstRect.offset().left + firstRect.width());
            distances.push(difference);
          }
          this.addScroll = distances.some(value => value < this.SPACE_THRESHOLD);
        }
      });
    }, 400)
  }
});